/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Info_Delete_AriaInputs */

const en_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete Record`)
};

const fr_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supprimer l'enregistrement`)
};

const de_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datensatz löschen`)
};

const it_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina record`)
};

const ru_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удалить запись`)
};

const es_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eliminar registro`)
};

const zh_cn2_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`删除记录`)
};

const ja_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レコードを削除`)
};

const hi_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रिकॉर्ड हटाएं`)
};

const pt_pt2_explorer_info_delete_aria = /** @type {(inputs: Explorer_Info_Delete_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Excluir registro`)
};

/**
* | output |
* | --- |
* | "Delete Record" |
*
* @param {Explorer_Info_Delete_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_info_delete_aria = /** @type {((inputs?: Explorer_Info_Delete_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Info_Delete_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_info_delete_aria(inputs)
	if (locale === "de") return de_explorer_info_delete_aria(inputs)
	if (locale === "it") return it_explorer_info_delete_aria(inputs)
	if (locale === "ru") return ru_explorer_info_delete_aria(inputs)
	if (locale === "es") return es_explorer_info_delete_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_info_delete_aria(inputs)
	if (locale === "ja") return ja_explorer_info_delete_aria(inputs)
	if (locale === "hi") return hi_explorer_info_delete_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_info_delete_aria(inputs)
	return en_explorer_info_delete_aria(inputs)
});